// extracted by mini-css-extract-plugin
export default {"btnPrimary":"custom-button_btnPrimary__BQkyI","btnSecondary":"custom-button_btnSecondary__pGT8T"};